import { useTranslate } from '@repo/shared/hooks'
import { Row, Skeleton, Typography } from '@repo/ui/components'
import type { OrderBoxInstantPriceProps } from './order-box.types'
import { InformationDialog, PaymentType } from '..'

export const OrderBoxInstantPrice = ({
  price,
  tab,
  inputCurrency,
  outputCurrency,
  isLoading = false,
  selectedAsset,
  isInstantPriceLoading = false,
}: OrderBoxInstantPriceProps) => {
  const { t } = useTranslate()

  const isSellWithoutAsset = tab === 'sell' && !selectedAsset
  const shouldHideInfo = tab === 'sell' && selectedAsset?.token === 'MALEK'

  return (
    <Row className='justify-between mb-md -mt-md'>
      <Row className='gap-2xs'>
        <Typography size='xs' color='text-neutral-surface-80'>
          {t(`order_instant_${tab}_price_label`)}
        </Typography>
        {!shouldHideInfo && (
          <InformationDialog title={t(`order_instant_${tab}_price_label`)}>
            {t(`info_instant_${tab}_price`)}
          </InformationDialog>
        )}
      </Row>
      {isSellWithoutAsset ? (
        '-'
      ) : isInstantPriceLoading || isLoading ? (
        <Skeleton className='h-4 w-32 rounded-md my-[4px]' />
      ) : (
        <PaymentType
          value={price}
          size='md'
          numberSize='md'
          inputCurrency={inputCurrency}
          outputCurrency={outputCurrency}
        />
      )}
    </Row>
  )
}
